import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/hooks/use-auth";
import { OperatorShell } from "@/components/operator-shell";
import { ScopeProvider } from "@/hooks/use-scope";
import { HotkeysProvider } from "@/hooks/use-hotkeys";
import { useDensity } from "@/hooks/use-density";

export const Route = createFileRoute("/_authenticated/app")({ component: AppLayout });

function AppLayout() {
  // Note: shell-mismatch routing (portal-only / no-access users) is handled
  // up-front by /src/routes/index.tsx based on primaryShell(roles).
  // Once a user is inside /app, role gates on specific subroutes handle the rest.
  // Avoid re-checking here so we don't pay a render + redirect on every nav.
  useAuth(); // keep subscription for any descendants that rely on it
  // Initialize density (applies the .density-* class to <html>)
  useDensity();

  return (
    <ScopeProvider>
      <HotkeysProvider>
        <OperatorShell>
          <Outlet />
        </OperatorShell>
      </HotkeysProvider>
    </ScopeProvider>
  );
}